/**
 * Workspace feature-flag keys and helpers. Flags ride the unit profile's
 * corePanelFlags map (merged with per-user my-view overrides server-side), so
 * they flow through both the local and Vertex manifest paths with no schema
 * changes. A flag is enabled unless explicitly set to false, so absent keys
 * never change behavior for existing units.
 */

/** corePanelFlags key gating the zoom-triggered Street View auto-dive. */
export const STREET_VIEW_AUTO_FLAG = 'street-view-auto';

/** Whether a flag is enabled — absent or true is enabled; only an explicit false disables. */
export function flagEnabled(flags: Record<string, boolean> | undefined, key: string): boolean {
  return flags?.[key] !== false;
}
